import { useContext, useEffect, useState } from 'react'
import { Stack, Text } from '@fluentui/react'
import { AppStateContext } from '../../state/AppProvider'
import { DashboardFilters } from '../../api/models'
import { getFilterPlans, getFilterUsers } from '../../api/api'
import FilterBar from '../../components/filters/FilterBar'
import PerformanceReport from '../../components/performance/PerformanceReport'
import { usePerformanceData } from '../../components/performance/usePerformanceData'

const Performance = () => {
  const appStateContext = useContext(AppStateContext)
  const state = appStateContext?.state
  const dispatch = appStateContext?.dispatch

  const [filters, setFilters] = useState<DashboardFilters>(state?.filters ?? {})
  const performance = usePerformanceData()

  const hasPlans = (state?.plans.length ?? 0) > 0
  const hasUsers = (state?.users.length ?? 0) > 0

  useEffect(() => {
    if (!dispatch) return
    if (!hasPlans) {
      getFilterPlans().then((plans) => dispatch({ type: 'SET_PLANS', payload: plans })).catch(() => {})
    }
    if (!hasUsers) {
      getFilterUsers().then((users) => dispatch({ type: 'SET_USERS', payload: users })).catch(() => {})
    }
  }, [dispatch, hasPlans, hasUsers])

  const handleApplyFilters = () => {
    dispatch?.({ type: 'SET_FILTERS', payload: { ...filters } })
  }

  return (
    <Stack tokens={{ childrenGap: 20 }}>
      <Text as="h1" variant="xLarge" styles={{ root: { margin: 0, fontWeight: 600 } }}>
        Performance &amp; cost
      </Text>
      <FilterBar
        filters={filters}
        plans={state?.plans ?? []}
        users={state?.users ?? []}
        onFiltersChange={setFilters}
        onApply={handleApplyFilters}
        isLoading={performance.status === 'loading'}
      />
      <PerformanceReport performance={performance} />
    </Stack>
  )
}

export default Performance
